(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivo-potential-points-widget-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  // Get all containers with data attributes - look for either subscription or buyonce
  var rivoContainers = document.querySelectorAll('.rivo-container-points-text--subscription, .rivo-container-points-text--buyonce');
  if (rivoContainers.length === 0) return;

  window.rivoWidget = window.rivoWidget || {};

  function getUSDValue(localValue) {
    if (window.Shopify && window.Shopify.currency) {
      var rate = window.Shopify.currency.rate;
      var normalized = localValue;
      var numericValue = Number(normalized);
      return numericValue / rate;
    }
    return Number(localValue.toString().replace(',', '.').replace(/[^0-9.]/g, ''));
  }

  function updatePotentialPoints(dataValue, productId, balanceAmount) {
    var usdValue = getUSDValue(dataValue);
    var roundedValue = Math.ceil(usdValue); // Match main widget logic (ceil)
    var points = roundedValue * (balanceAmount || 1);
    var pointsSpan = document.getElementById(productId);
    if (pointsSpan) {
      pointsSpan.textContent = points;
    }
  }

  // Loop through each container and process individually
  rivoContainers.forEach(function(rivoContainer) {
    var productPrice;
    var productId = rivoContainer.dataset.productId;

    // Debug logging
    console.log('Processing container:', rivoContainer);
    console.log('Product ID:', productId);
    console.log('Container classes:', rivoContainer.className);
    console.log('Subscription price data:', rivoContainer.dataset.subscriptionPrice);
    console.log('Regular price data:', rivoContainer.dataset.priceValue);

    // Use subscription price if product type is subscription, otherwise use regular price
    if (rivoContainer.classList.contains('rivo-container-points-text--subscription')) {
      productPrice = parseFloat(rivoContainer.dataset.subscriptionPrice);
      console.log('Using subscription price:', productPrice);
    } else if (rivoContainer.classList.contains('rivo-container-points-text--buyonce')) {
      productPrice = parseFloat(rivoContainer.dataset.priceValue);
      console.log('Using regular price:', productPrice);
    }

    // retrieve balance multiplier (defaults to 1 in markup currently)
    var balanceAmount = parseFloat(rivoContainer.dataset.balanceAmount) || 1;

    console.log('Final productPrice:', productPrice);
    console.log('Target element:', document.getElementById(productId));

    // Only run if we have valid price and product ID
    // Fallback chain if price is invalid or zero
    if ((productPrice === undefined || isNaN(productPrice) || productPrice === 0) && rivoContainer.classList.contains('rivo-container-points-text--subscription')) {
      productPrice = parseFloat(rivoContainer.dataset.subscriptionPrice);
    }
    if ((productPrice === undefined || isNaN(productPrice) || productPrice === 0)) {
      productPrice = parseFloat(rivoContainer.dataset.compareAtPrice);
    }

    if (productPrice !== undefined && !isNaN(productPrice) && productId) {
      updatePotentialPoints(productPrice, productId, balanceAmount);
    } else {
      console.log('Skipping update - invalid data:', {
        productPrice: productPrice,
        isNaN: isNaN(productPrice),
        productId: productId
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rivo-potential-points"] && !Shopify.designMode) return;
  try {
    var noPointsText = document.querySelector('.rivo-container-points').getAttribute('data-no-points-text');

function getUSDValue(localValue) {
  if (window.Shopify && window.Shopify.currency) {
    var rate = window.Shopify.currency.rate;
    // Replace comma with dot for decimal, remove all but digits and dot
    var normalized = localValue.replace(',', '.').replace(/[^0-9.]/g, '');
    var numericValue = Number(normalized);
    return numericValue / rate;
  }
  return Number(localValue.replace(',', '.').replace(/[^0-9.]/g, ''));
}

function updatePotentialPoints(dataValue) {
  var balanceAmount = Number(document.querySelector('.rivo-container-points').getAttribute('data-balance-amount')) || 1;
  var usdValue = getUSDValue(dataValue);
  var roundedValue = Math.ceil(usdValue);
  var points = roundedValue * balanceAmount;
  var pointsSpan = document.getElementById('rivo-points-value');
  if (isNaN(points) || !isFinite(points) || points === 0) {
    // Hide the points text
    var pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = 'none';
    // Remove any previous .rivo-sentence
    var prevSentence = document.querySelector('.rivo-sentence');
    if (prevSentence && prevSentence.parentNode) prevSentence.parentNode.removeChild(prevSentence);
    // Add a new sentence
    var container = document.querySelector('.rivo-potential-text');
    if (container) {
      var p = document.createElement('p');
      p.className = 'rivo-sentence';
      p.textContent = noPointsText || '';
      container.appendChild(p);
    }
  } else {
    // Show the points text
    var pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = '';
    // Remove any previous .rivo-sentence
    var prevSentence = document.querySelector('.rivo-sentence');
    if (prevSentence && prevSentence.parentNode) prevSentence.parentNode.removeChild(prevSentence);
    if (pointsSpan) pointsSpan.textContent = points;
  }
  var potentialText = document.querySelector('.rivo-container-points');
  if (potentialText) potentialText.style.display = '';
  return points;
}

document.addEventListener('DOMContentLoaded', function() {
  var deliveryInputs = document.querySelectorAll('[name="delivery"]');
  // Get the default checked input on load
  var checkedInput = document.querySelector('[name="delivery"]:checked');
  if (checkedInput) {
    var defaultValue = checkedInput.getAttribute('data-value-points');
    var pointsDefault = updatePotentialPoints(defaultValue);
  }
  deliveryInputs.forEach(function(input) {
    input.addEventListener('click', function() {
      var dataValue = input.getAttribute('data-value-points');
      var points = updatePotentialPoints(dataValue);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
